import { DocumentServicesObject } from '@wix/document-services-types';
import { createFeedbackLoop } from '@wix/feedback-loop';
import { RequestFeedbackOptions } from '@wix/editor-platform-sdk-types';

const state: {
  form?: ReturnType<typeof createFeedbackLoop>;
} = {};

export const openFeedbackForm = async (
  documentServices: DocumentServicesObject,
  {
    appDefinitionId,
    ...options
  }: RequestFeedbackOptions & { appDefinitionId: string },
) => {
  if (state.form) {
    return;
  }

  const form = createFeedbackLoop({
    uuid: documentServices.generalInfo.getUserInfo().userId,
    editorType: window.commonConfig?.host,
    msid: documentServices.generalInfo.getMetaSiteId(),
    esi: window.editorModel?.editorSessionId,
    language: documentServices.generalInfo.getLanguage(),
    appDefId: appDefinitionId,
    ...options,
  });

  state.form = form;

  try {
    const data = await form.open();
    // TODO: integrate with form close reasons
    state.form = undefined;
    return data;
  } catch (e) {
    state.form = undefined;
    throw e;
  }
};

export const closeFeedbackForm = () => {
  state.form?.close();
  state.form = undefined;
};

const FEEDBACK_LOOP_HIDE_TRIGGERS = [
  // Site Preview
  'documentMode.setComponentViewMode',
];

export const init = (documentServicesAPI: DocumentServicesObject) => {
  documentServicesAPI.registerToSiteChanged((updates?: string[]) => {
    if (
      updates &&
      updates.length &&
      updates.some((update) => FEEDBACK_LOOP_HIDE_TRIGGERS.includes(update))
    ) {
      if (
        documentServicesAPI.documentMode.getComponentViewMode() === 'preview'
      ) {
        state.form?.hide();
      } else {
        state.form?.show();
      }
    }
  });
};
